import Plyr from 'plyr';

const audioTranscription = {
    init() {
        const root = document.querySelector('[data-audio-transcription]');

        if (!root || root.dataset.audioTranscriptionInit === 'true') {
            return;
        }

        root.dataset.audioTranscriptionInit = 'true';

        const entryId = root.getAttribute('data-entry-id');
        const siteId = root.getAttribute('data-site-id');

        if (!entryId || !siteId) {
            return;
        }

        const playerWrapper = root.querySelector('[data-audio-transcription-player]');
        const initialUrl = playerWrapper?.getAttribute('data-initial-audio');

        // Public pages should never trigger generation.
        // If an audio asset already exists, render it; otherwise keep the placeholder.
        if (initialUrl) {
            setTimeout(() => {
                this.renderPlayer(playerWrapper, initialUrl);
            }, 0);
        }
    },

    renderPlayer(wrapper, url) {
        if (!wrapper || !url) {
            return;
        }

        const existing = wrapper.querySelector('audio');

        if (existing) {
            if (existing.getAttribute('src') !== url) {
                existing.setAttribute('src', url);
                existing.load();
            }

            return;
        }

        const audio = document.createElement('audio');
        audio.className = 'js-player w-full';
        audio.setAttribute('controls', '');
        audio.setAttribute('preload', 'metadata');
        audio.setAttribute('src', url);

        wrapper.innerHTML = '';
        wrapper.appendChild(audio);

        wrapper.classList.add('is-loaded');

        new Plyr(audio);
    },
};

export default audioTranscription;

